import { useSelector } from 'react-redux';
import { getCustomerMarket } from '@app/redux/customer/selectors';

const useCustomerMarket = () => {
  const marketName = useSelector(getCustomerMarket) as string;

  return { marketName: marketName || null };
};

export default useCustomerMarket;
